// 卖家网 搜索项里的行业 和其他页面中的行业是不同的  两个接口 
// 导入弹窗中的下拉
export const getmaijiaProfession_api = {
  title: "卖家网行业下拉",
  url: "maijiawangProfession",
  method: "get"
};

// 下拉接口描述对象
export const getplatlists_api = {
  title: "平台",
  url: "getplatlists",
  method: "get"
};

// 卖家网行业 导入弹窗中的下拉
// export const getmaijiawangProfession = {
//   title: "",
//   url: "maijiawangProfession",
//   method: "get"
// };
// export const getptnlists_api = {
//   title: "商家",
//   url: "getptnlists",
//   method: "get"
// };
// 旧版本
// export const getshoplists_api = {
//   title: "店铺",
//   url: "getShopByPtn",
//   method: "get",
// };


export const getbrdlists_api = {
  title: "品牌",
  url: "getbrdlists",
  method: "get"
};
export const getordtype_api = {
  title: "订单类型",
  url: "/getordtype",
  method: "get"
};

export const getordsign_api = {
  title: "订单标记",
  url: "getordsign",
  method: "get"
};

export const getoutstkflag_api = {
  title: "订单发货状态",
  url: "getoutstkflag",
  method: "get",
  param: {
    platCode: "TB"
  }
};

export const getplatordstatus_api = {
  title: "订单状态",
  url: "getplatordstatus",
  method: "get",
  param: {
    platCode: "TB"
  }
};

export const getstrlists_api = {
  title: "仓库",
  url: "getstrlists",
  method: "get"
};

export const getinvstatuslists_api = {
  title: "库存状态",
  url: "getinvstatuslists",
  method: "get"
};
export const getinvsendstatuslists_api = {
  title: "库存下单状态",
  url: "getinvsendstatuslists",
  method: "get"
};

// 根据商家店铺获取 sku
// getSkuByPtnShop_api
export const getSkuByPtnShop_api = {
  title: "根据商家店铺获取 sku",
  url: "getSkuByPtnShop",
  method: "post",
  param: {
    pthCode: "",
    shopCode: ""
  }
};

// 根据商家店铺获取 赠品 sku
// getSkuByPtnShop_api
export const getGiftSkuByPtnShop_api = {
  title: "根据商家店铺获取 赠品sku",
  url: "getSkuByPtnShop",
  method: "post",
  param: {
    pthCode: "",
    shopCode: "",
    giftFlag: "T"
  }
};

export const TFList = [
  {
    label: "是",
    value: "T"
  },
  {
    label: "否",
    value: "F"
  }
];
export const IOType = [
  {
    label: "出库",
    value: 1
  },
  {
    label: "入库",
    value: 2
  }
];
// OutstkFlag
export const OutstkFlagList = [
  {
    label: "已撤销",
    value: 0
  },
  {
    label: "待审核",
    value: 1
  },
  {
    label: "已审核",
    value: 2
  },
  {
    label: "已发指示",
    value: 3
  },
  {
    label: "收到实绩",
    value: 4
  },
  {
    label: "待复核",
    value: 9
  }
];
// babel插件可以支持
// export * as Select from "./index";

export const qualityType = [
  {
    label: "正品",
    value: 1
  },
  {
    label: "残次",
    value: 2
  },
  {
    label: "其他",
    value: 3
  }
];

// 赠品管理
// 互斥活动ID下拉项
export const getActEventByPtnShop_api = {
  title: "",
  url: "getActEventByPtnShop",
  method: "post",
  param: {
    ptnCode: "",
    shopCode: ""
  }
};
// 3.0.6.0 获取库存分配方式
// getStkSetType
export const getStkSetType_api = {
  url: "getStkSetType",
  method: "get"
};

// 3.0.5.0 获取拆分合并订单规则
export const getordrules_api = {
  title: "获取拆分合并订单规则",
  url: "getordrules",
  method: "get",
  param: {},
  query: {
    type: "" // 类型：1拆分，2合并,只允许数字。
  }
};

// 平台状态

// 根据商家店铺 获取 仓库和货主信息

// getownerbyptnshop

export const getownerbyptnshop_api = {
  title: "根据商家店铺获取仓库和货主信息",
  url: "getownerbyptnshop",
  method: "get",
  param: {},
  query: {
    ptnCode: "",
    shopCode: "",
  }
};
export const getinvstockstatuslists_api = {
  title: "入库状态",
  url: "getinvstockstatuslists",
  method: "get",
  param: {},
};

// ~~~~~~~~~~~~~~~~
export const gettradestatus_api = {
  title: "订单状态接口地址",
  url: "gettradestatus",
  method: "get",
  param: {},
};

export const gettradefrom_api = {
  title: "来源平台接口地址",
  // url: "gettradefrom",
  url: "getplatlists",
  method: "get",
  param: {},
};

export const getprofession_api = {
  title: "行业列表接口地址",
  url: "getprofession",
  method: "get",
  param: {},
};

export const getptnlists_api = {
  title: "商家列表接口地址",
  url: "getptnlist",
  method: "get",
  param: {
    profCode: "", // 行业code
  },
};

export const getshoplists_api = {
  title: "店铺",
  url: "getshopbyptn",
  method: "get",
  query: {
    ptnCode: ""
  }
};

// 会员 基础 导出
export const memberInfoListsDownload_api = {
  url: 'memberInfoListsDownload',
  title: '导出',
  method: 'post'
}

export const getrefundstatus_api = {
  title: "退款单状态",
  url: "getrefundstatus",
  method: "get",
  param: {},
};

export const getrefundreason_api = {
  title: "退款原因",
  url: "getrefundreason",
  method: "get",
  param: {},
};


// WEBPACK FOOTER //
// ./src/common/js/select-data-api/index.js